import React from 'react'
import NavBar from './navBar'
import Footer from './Footer'
import img1 from "../../assets/latestProd1.svg"
import img2 from "../../assets/latestProd2.svg"
import img3 from "../../assets/latestProd3.svg"
import img4 from "../../assets/latestProd4.svg"
import img5 from "../../assets/latestProd5.svg"
import img6 from "../../assets/latestProd6.svg"


const LatestProductFeature = () => {


    const cards=[
        {
            img:img1,
            title:"AI-Powered Candidate Matching",
            desc:"Leverage advanced algorithms to match candidates with the best job opportunities based on their skills and experience.",

        },
        {
            img:img2,
            title:"Job Posting Management using Tracking",
            desc:"Seamlessly create, manage, and track job postings across various job boards and platforms.pportunities based on their skills and experience."
        },
        {
            img:img3,
            title:"Real-Time Applicant Tracking Management",
            desc:"Monitor the status of applications in real-time, providing quick updates and insights to help recruiters stay on top of their hiring process."
        },
        {
            img:img4,
            title:"Candidate Resume Database Access",
            desc:"Access a global database of qualified candidates and search resumes based on specific criteria and skill sets."
        },
        {
            img:img5,
            title:"Team Collaboration Tools, chatbox, chat support",
            desc:"Leverage advanced algorithms to match candidates with the best job opportunities based on their skills and experience."
        },
        {
            img:img6,
            title:"Integrated Onboarding Solutions",
            desc:"Leverage advanced algorithms to match candidates with the best job opportunities based on their skills and experience."
        }
    ]
  return (
    <>
    <NavBar/>
    <div className='latest-product-feature'>
    <div className='latest-product-container'>
          <p className='latest-produt-url'>Home/Platform/Latest product features</p>
        <p className='latest-product-head'>
            Latest product features
        </p>
        <p className='latest-product-desc'>Feature that provide an easy-to-use interface for candidates to search, filter, and apply to job listings.</p>
    </div>
    </div>
    <div className='latest-products-container'>
    <div className='latest-products' style={{margin:"20px 0px"}}>
        {
            cards.map((card,index)=>{
                return(
                    <div className='latest-card'>
                        <img src={card.img}/>
                        <p className='latest-card-head'>{card.title}</p>
                        <p className='latest-card-desc'>{card.desc}</p>
                        </div>
                )
            })
        }
    </div>
    </div>
    <Footer/>
    </>
  )
}

export default LatestProductFeature